import Dropzone from "react-dropzone";
import { useState } from "react";
import * as XLSX from 'xlsx';

export default function DataUploader({ setData, setCourseStatistics }) {
    const [isLoading, setIsLoading] = useState(false);

    const processData = (acceptedFiles) => {
        if (!acceptedFiles || acceptedFiles.length === 0) {
            alert("Keine Datei ausgewählt");
            return;
        }
        setIsLoading(true);
        const file = acceptedFiles[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = event.target.result;
            let readData = XLSX.read(data, { type: 'binary' });
            const wsname = readData.SheetNames[0];
            const ws = readData.Sheets[wsname];
            const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1});
            const courseData = [];
            const courseStatistics = { courses: {}, info: { totalEntries: 0 }};
            for (let i = 1; i < dataParse.length; i++) {
                const row = dataParse[i];
                const id = row[0];
                const startzeit = row[1];
                const endzeit = row[2];
                const eMail = row[3];
                const name = row[4];
                const choice1 = row[5];
                const choice2 = row[6];
                const choice3 = row[7];
                const choice4 = row[8];
                const choice5 = row[9];
                courseData.push({ id, startzeit, endzeit, eMail, name, choice1, choice2, choice3, choice4, choice5 });
                for (let value of [choice1, choice2, choice3, choice4, choice5]) {
                    if (!value) continue;
                    if (Object.keys(courseStatistics.courses).includes(value)) {
                        courseStatistics.courses[value] += 1;
                    } else {
                        courseStatistics.courses[value] = 1;
                    }
                }
                courseStatistics.info.totalEntries += 1;
            }
            courseStatistics.info.totalCourses = Object.keys(courseStatistics.courses).length;
            setData(courseData);
            setCourseStatistics(courseStatistics);
            setIsLoading(false);
        }
        reader.readAsBinaryString(file);
    }
        
    return (
        <>
        {isLoading ? <p>Verarbeite Daten...</p> : 
            <Dropzone onDrop={processData}>
            {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} style={{ border: '2px dashed #ccc', padding: '20px', textAlign: 'center' }}>
                    <input {...getInputProps()} />
                    <p>Bitte Excel-Datei hierher ziehen oder klicken, um eine Datei auszuwählen.</p>
                </div>
            )}
        </Dropzone> }
        </>
    )
}